var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/nsips-clinic-list.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-4a3873ce!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/nsips-clinic-list.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/NsipsClinicList.vue
// module id = 327
// module chunks = 1